<template>
  <form
    data-testid="login-form"
    @submit.prevent="complete"
  >
    <div class="grid justify-items-center space-y-6">
      <vetster-logo-title :title="$t('login.welcome-back-to-vetster')" />

      <div class="space-y-4 w-full">
        <vetster-input
          v-model.trim="v$.inputs.email.$model"
          name="email"
          :label="$t('common.email')"
          autocomplete="off"
          :disabled="isLoading"
          :shake="shouldShake('email', v$.inputs.email.$error)"
          :error="hasError('email', v$.inputs.email.$error)"
          :feedback="getErrorMessage('email', v$.inputs.email.$error, $t('login.errors.please-enter-email'))"
          is-rebranded
        />
        <vetster-input
          ref="passwordInput"
          v-model.trim="v$.inputs.password.$model"
          :label="$t('common.password')"
          name="password"
          type="password"
          autocomplete="current-password"
          :disabled="isLoading"
          :shake="shouldShake('password', v$.inputs.password.$error)"
          :error="hasError('password', v$.inputs.password.$error)"
          :feedback="getErrorMessage('password', v$.inputs.password.$error, $t('login.errors.please-enter-password'))"
          is-rebranded
        />
      </div>
      <div class="w-full">
        <vetster-button
          type="submit"
          variant="ocean"
          class="w-full"
          data-testid="password-login-btn"
          size="lg"
          :disabled="isLoading"
          :is-loading="isLoading"
          @click="complete"
        >
          {{ $t('app.log-in') }}
        </vetster-button>
        <div class="mt-4 text-center">
          <a
            href="#"
            class="underline text-ocean-950 text-sm"
            @click.prevent="$emit('forgot-password')"
          >
            {{ $t('login.forgot-password') }}
          </a>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import useVuelidate from '@vuelidate/core';
import { email, required } from '@vuelidate/validators';
import isEmpty from 'lodash/isEmpty';

import VetsterLogoTitle from '@/brand-components/VetsterLogoTitle';
import ParseErrors from '@/mixins/ParseErrors';

export default {
  name: 'VetsterPasswordLogin',

  components: { VetsterLogoTitle },

  mixins: [ParseErrors],

  props: {
    error: {
      type: Object,
      default: () => ({}),
    },
    email: {
      type: String,
      required: true,
    },
    isLoading: {
      type: Boolean,
      required: true,
    },
  },

  setup() {
    return { v$: useVuelidate() };
  },

  data() {
    return {
      inputs: {
        email: '',
        password: null,
      },
    };
  },

  watch: {
    error(err) {
      if (!isEmpty(err)) {
        this.parseError(err);
      }
    },
  },

  created() {
    this.inputs.email = this.email;

    this.$analytics.trackGA({ eventName: 'gx:identity:login:load' });
  },

  mounted() {
    this.$refs.passwordInput.focus();
  },

  validations: {
    inputs: {
      email: {
        required,
        email,
      },
      password: {
        required,
      },
    },
  },

  methods: {
    complete() {
      this.v$.inputs.$reset();
      this.v$.inputs.$touch();

      if (this.v$.inputs.$invalid) {
        this.shakeErrors = true;
        this.removeShake();

        return;
      }

      this.$emit('complete', this.inputs);
    },
  },
};
</script>
